export const patchData2025 = [
  {
    id: "jan-25",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Januari - Notes",
    year: "2025",
    description:
      "Perubahan pada halaman Data Processing, Non Projected Reporting, dan Audit Plan.",
    changelog: [
      "Data Processing: Perbaikan dan penyesuaian perhitungan.",
      "Non Projected Reporting: Perbaikan dan penyesuaian data.",
      "Audit Plan: Validasi pada Database",
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing",
        date: "03 Januari 2025",
        items: [
          "Perbaikan perhitungan data untuk RDC_GT",
          "Menyesuaikan nilai default data adj_factor",
        ],
      },
      {
        id: 2,
        title: "Non Projected Reporting",
        date: "03 Januari 2025",
        items: ["Penyesuaian Survey RDC terkait pemindahan keterangan data"],
      },
      {
        id: 3,
        title: "Audit Plan",
        date: "03 Januari 2025",
        items: [
          "Pengecekan Import Audit Plan pada Database",
          "Pengecekan ketidaksesuaian Edit Audit Plan pada Database",
        ],
      },
    ],
  },
  {
    id: "feb-25",
    type: ["Backend"],
    color: ["#ff8a65"],
    title: "Februari - Notes",
    year: "2025",
    description: "Perubahan pada halaman Product Master dan sistem transfer.",
    changelog: [
      "Product Master: Import Product.",
      "Other: Perbaikan transfer data.",
    ],
    datas: [
      {
        id: 1,
        title: "Product Master",
        date: "01 Februari 2025",
        items: ["Mengubah sistem import product"],
      },
      {
        id: 2,
        title: "Other",
        date: "21 Februari 2025",
        items: ["Perbaikan transfer data harian untuk semua TRX"],
      },
    ],
  },
  {
    id: "mar-25",
    type: ["Interface"],
    color: ["#4db6ac"],
    title: "Maret - Notes",
    year: "2025",
    description:
      "Perubahan pada halaman Non Projected Reporting, Product Master, Data Survey, Store Master, Login, License, dan pengelolaan wilayah.",
    changelog: [
      "Non Projected Reporting: Penambahan fitur sync dan pengelolaan wilayah.",
      "Product Master: Perubahan tampilan dan penyimpanan filter.",
      "Data Survey: Pembatasan hak edit.",
      "Store Master: Penyederhanaan input dan perubahan tampilan.",
      "Login & License: Redesign tampilan halaman.",
      "Wilayah: Penambahan tabel region dan wilayah.",
    ],
    datas: [
      {
        id: 1,
        title: "Non Projected Reporting",
        date: "10 Maret 2025",
        items: [
          "Mengizinkan Sync Rawdata dari role CO-ADMIN",
          "Manajemen create & edit untuk Area, Wilayah, serta Region",
          "Manajemen Assign Area",
        ],
      },
      {
        id: 2,
        title: "Product Master",
        date: "10 Maret 2025",
        items: [
          "Menyimpan riwayat filter terakhir yang dipilih",
          "Setelah create/edit salah satu Product, filter yang sebelumnya disimpan akan otomatis ditampilkan",
          "Perubahan konsep dari Modal Add/Edit Product menjadi Halaman Add/Edit Product",
          "Filter data group, category, brand, principal bisa dicari",
        ],
      },
      {
        id: 3,
        title: "Data Survey",
        date: "10 Maret 2025",
        items: ["Menonaktifkan edit data untuk Tipe Project ADHOC dan RAK1"],
      },
      {
        id: 4,
        title: "Store Master",
        date: "10 Maret 2025",
        items: [
          "Perubahan urutan posisi input pada Add Store",
          "Perubahan konsep dari Modal Add/Edit Store menjadi Halaman Add/Edit Store",
          "Default tipe lokasi saat Add Store adalah Unspecify",
        ],
      },
      {
        id: 5,
        title: "Login",
        date: "10 Maret 2025",
        items: ["Redesign tampilan baru untuk halaman Login"],
      },
      {
        id: 6,
        title: "License",
        date: "10 Maret 2025",
        items: ["Redesign tampilan baru untuk halaman License"],
      },
      {
        id: 7,
        title: "Other",
        date: "10 Maret 2025",
        items: ["Table baru untuk Region dan Wilayah"],
      },
    ],
  },
  {
    id: "apr-25",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "April - Notes",
    year: "2025",
    description:
      "Perubahan pada halaman Data Survey, Non Projected Reporting, dan PBI Data.",
    changelog: [
      "Data Survey: Penambahan fitur export rawdata.",
      "Non Projected Reporting: Penambahan perhitungan di laporan.",
      "PBI Data: Pembuatan akses data eksternal.",
    ],
    datas: [
      {
        id: 1,
        title: "Data Survey",
        date: "23 Maret 2025",
        items: [
          "Export rawdata untuk Tipe Project ADHOC menampilkan list question fact, code, description secara dinamis",
        ],
      },
      {
        id: 2,
        title: "Non Projected Reporting",
        date: "21 Maret 2025",
        items: [
          "Perbaikan perhitungan data dan penyesuaian detail pada data report",
        ],
      },
      {
        id: 3,
        title: "PBI Data",
        date: "21 Maret 2025",
        items: ["Data external untuk akses melalui Power BI"],
      },
    ],
  },
  {
    id: "mei-25",
    type: ["Interface", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "Mei - Notes",
    year: "2025",
    description:
      "Perubahan pada Stat Modules, Non Projected Reporting, dan halaman Patch Notes.",
    changelog: [
      "Stat Modules: Hapus create data.",
      "Non Projected Reporting: Perbaikan perhitungan data.",
      "Patch Notes: Halaman baru.",
    ],
    datas: [
      {
        id: 1,
        title: "Stat Modules",
        date: "28 Mei 2025",
        items: [
          "Hapus create data pada provinsi, kab/kota, dan kecamatan",
        ],
      },
      {
        id: 2,
        title: "Non Projected Reporting",
        date: "30 Mei 2025",
        items: [
          "Perbaikan perhitungan data dan penyesuaian detail pada RDC Pharmacy Price by Area",
        ],
      },
      {
        id: 3,
        title: "Patch Notes",
        date: "16 Mei 2025",
        items: ["Halaman baru untuk melihat dokumentasi update website sivina."],
      },
      {
        id: 4,
        title: "Other",
        date: "30 Mei 2025",
        items: ["Perbaikan tampilan navbar agar lebih responsif"],
      },
    ],
  },
  {
    id: "jun-25",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "Juni - Notes",
    year: "2025",
    description:
      "Perubahan pada halaman Setup Product Master, Stat Modules, Product Master, Project Management, dan Store Master.",
    changelog: [
      "Setup Product Master: Penambahan tipe category.",
      "Stat Modules: Edit area, defaulr value, dan penyesuaian",
      "Product Master: Import & assign new product group",
      "Project Management: Create project with product group",
      "Store Master: Penyesuaian akses superadmin",
    ],
    datas: [
      {
        id: 1,
        title: "Setup Product Master",
        date: "03 Juni 2025",
        items: ["Menambah tipe Category namun view-only"],
      },
      {
        id: 2,
        title: "Stat Modules",
        date: "5 Juni 2025",
        items: [
          "Create provinsi, kab/kota, dan kecamatan melalui modal create & edit kelurahan",
          "Default input area adalah unspecify",
          "Penyesuaian refresh data provinsi, kab/kota, dan kecamatan di BPS Kelurahan",
          "Edit area mapping",
        ],
      },
      {
        id: 3,
        title: "Product Master",
        date: "26 Juni 2025",
        items: ["Create dan assign import new product group"],
      },
      {
        id: 4,
        title: "Project Management",
        date: "26 Juni 2025",
        items: ["Create project dengan memilih product group yang ada"],
      },
      {
        id: 5,
        title: "Store Master",
        date: "26 Juni 2025",
        items: ["Superadmin bisa akses fungsi dan halaman edit"],
      },
      {
        id: 6,
        title: "License",
        date: "03 Juni 2025",
        items: ["List license pada navbar berada di paling bawah"],
      },
    ],
  },
  {
    id: "jul-25",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Juli - Notes",
    year: "2025",
    description:
      "Perubahan pada halaman Report Non Projected, Data Processing, Stat Modules, Sync Rawdata, Export Rawdata",
    changelog: [
      "Report Non Projected: Perhitungan by filter baru.",
      "Data Processing: Perhitungan data",
      "Stat Modules: Upload excel data",
      "Sync Rawdata: Pembuatan fungsi Sync Rawdata",
      "Export Rawdata: Perbaikan export",
    ],
    datas: [
      {
        id: 1,
        title: "Report Non Projected",
        date: "11 Juli 2025",
        items: [
          "Menambah filter baru terkait multiple category",
        ],
      },
      {
        id: 2,
        title: "Data Processing",
        date: "11 Juli 2025",
        items: [
          "Perbaikan perhitungan market share unit dan value pada RTA GT",
        ],
      },
      {
        id: 3,
        title: "Stat Modules",
        date: "16 Juli 2025",
        items: ["Penambahan fungsi upload pada mbd, cell code mapping, store panel cell, dan kelurahan"],
      },
      {
        id: 4,
        title: "Sync Rawdata",
        date: "16 Juli 2025",
        items: ["Menambah fungsi sync rawdata untuk data yang belum ada pada table raw"],
      },
      {
        id: 5,
        title: "Export Rawdata",
        date: "24 Juli 2025",
        items: ["Perbaikan export rawdata"],
      },
    ],
  },
  {
    id: "agu-25",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "Agustus - Notes",
    year: "2025",
    description:
      "Pengembangan pada halaman Data Processing, Report, dan Data Survey",
    changelog: [
      "Report: Penyesuaian perhitungan RDC GT",
      "Data Processing: Penambahan tipe project baru RTA MT, perhitungan baru RDC GT, history Calculation P Factor",
      "Data Survey: Perubahan sistem edit pada TRX"
    ],
    datas: [
      {
        id: 1,
        title: "Report",
        date: "19 Agustus 2025",
        items: [
          "⁠RDC GT Undup Gabungan custom total and sub total",
        ],
      },
      {
        id: 2,
        title: "Data Processing",
        date: "29 Agustus 2025",
        items: [
          "Penambahan tipe project untuk RTA MT",
          "Upload new period atau current period untuk setiap retailer",
          "Crosscoding brand & crosscoding product RTA MT",
          "Generate DB menggunakan tipe project & period pada proses RTA MT",
          "⁠Perhitungan baru numeric distribution untuk RDC GT",
          "Calculation P Factor menyimpan history Cell dan Store Cell"
        ],
      },
      {
        id: 3,
        title: "Data Survey",
        date: "29 Agustus 2025",
        items: [
          "Perubahan sistem edit pada TRX agar bisa digunakan secara dinamis.",
        ],
      },
    ],
  },
  {
    id: "sep-25",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "September - Notes",
    year: "2025",
    description:
      "Pengembangan pada halaman Data Processing, User Management, Profile, Product Master, dan Report Non Projected",
    changelog: [
      "Data Processing: Penyesuaian labeling & tampilan, upload retailers, dan crosscoding",
      "User Management: Role Based Access Control",
      "Profile: Penambahan halaman baru",
      "Product Master: Penyesuaian export excel",
      "Report Non Projected: Penambahan report baru",
      "Other: Perubahan nama label dan column"
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing",
        date: "24 September 2025",
        items: [
          "Perubahan labeling Import jadi Upload",
          "Fitur filter dan pencarian di Crosscoding",
          "Fitur untuk Upload All Retailers",
          "Pengecheckan pada fungsi upload retailer di RTA MT",
          // "Fitur pencarian dengan fuzzy matching",
          "Export list crosscoded/excluded brand dan product"
        ],
      },
      {
        id: 2,
        title: "User Management",
        date: "16 September 2025",
        items: [
          "Penyesuaian akses berdasarkan masing-masing role",
          "Perubahan tampilan dan optimalisasi fitur",
        ],
      },
      {
        id: 3,
        title: "Profile",
        date: "16 September 2025",
        items: [
          "Pembuatan halaman baru untuk profile",
          "Fitur untuk mengubah password/kata sandi",
        ],
      },
      {
        id: 4,
        title: "Product Master",
        date: "17 September 2025",
        items: [
          "Penyesuaian output export excel berdasarkan tipe setup product master",
          "Fitur pencarian pada pada setup brand category master",
          "Perubahan nama label dan column",
        ],
      },
      {
        id: 5,
        title: "Report Non Projected",
        date: "17 September 2025",
        items: [
          "Penambahan Report by Region di RTA GT, RDC GT, dan RTA MT",
          "Fitur pencarian pada pada setup brand category master",
          "Perubahan nama label dan column",
        ],
      },
      {
        id: 6,
        title: "Other",
        date: "23 September 2025",
        items: [
          "Perubahan nama label dan column",
        ]
      }
    ],
  },
  {
    id: "okt-25",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Oktober - Notes",
    year: "2025",
    description:
      "Pengembangan pada halaman Data Processing, Audit Plan, dan Report Non Projected",
    changelog: [
      "Audit Plan: Perbaikan fitur",
      "Report Non Projected: Penambahan report",
      "Data Processing: Perbaikan validasi dan export crosscoding",
    ],
    datas: [
      {
        id: 1,
        title: "Audit Plan",
        date: "30 Oktober 2025",
        items: [
          "Perbaikan fitur sort order by",
        ],
      },
      {
        id: 2,
        title: "Report Non Projected",
        date: "30 Oktober 2025",
        items: [
          "Pembuatan Report by Region untuk RTA GT, RDC GT, RDC MT ",
        ],
      },
      {
        id: 3,
        title: "Data Processing",
        date: "30 Oktober 2025",
        items: [
          "Perbaikan step Calculation Pfactor",
          "Download Excel List Crosscoded & Excluded Brand/Product"
        ],
      },
    ],
  },
  {
    id: "nov-25",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "November - Notes",
    year: "2025",
    description:
      "Pengembangan pada halaman Data Processing dan Report Non Projected",
    changelog: [
      "Data Processing: Revisi Numeric Distribution & Validasi",
      "Report Non Projected: Perbaikan fitur",
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing",
        date: "30 November 2025",
        items: [
          "Revisi Data Preparation RDC GT Numeric Distribution",
          "Data Preparation Perbaikan Validasi Step 6 Calculation Pfactor"
        ],
      },
      {
        id: 2,
        title: "Report Non Projected",
        date: "30 November 2025",
        items: [
          "Perbaikan filter Survey Type & Category Master di Report by Region",
          "Perbaikan sorting store di Report Non Projected RDC GT, RDC MT, dan RDC Pharmacy"
        ],
      },
    ],
  },
  {
    id: "des-25",
    type: ["Backend"],
    color: ["#ff8a65"],
    title: "Desember - Notes",
    year: "2025",
    description:
      "Pengembangan pada halaman Report Non Projected",
    changelog: [
      "Report Non Projected: Penambahan report",
    ],
    datas: [
      {
        id: 1,
        title: "Report Non Projected",
        date: "02 Desember 2025",
        items: [
          "Pembuatan Report by Price by Area untuk RTA GT",
        ],
      },
    ],
  },
]
